// Chakra imports
import {
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
// Custom components
import Chart from "react-apexcharts";
import React, { useEffect } from "react";

export default function WeeklyRevenue(props) {
  const { finalData, setFinalData } = props;

  useEffect(() => {
    //console.log("keywordsArray", finalData);
  }, [finalData]);

  const barChartDataConsumption = [
    {
      name: "Suspicious",
      data: finalData.map((it) => it.suspicious),
    },
    {
      name: "Reported",
      data: finalData.map((it) => it.reported),
    },
    {
      name: "Removed",
      data: finalData.map((it) => it.removed),
    },
  ];

  const barChartOptionsConsumption = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      background: 'transparent',
      foreColor: '#545454',
      fontFamily: 'inherit',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      }
    },
    tooltip: {
      enabled: true,
      theme: 'light',
      style: {
        fontSize: '13px',
        fontFamily: 'inherit',
      },
      y: {
        formatter: function (val) {
          return val.toLocaleString();
        }
      },
      marker: {
        show: true,
      },
      shared: false,
      intersect: true,
      followCursor: true,
      fillSeriesColor: false,
      onDatasetHover: {
        highlightDataSeries: true,
      },
    },
    xaxis: {
      categories: finalData.map((it) => it.brands || it.Platforms),
      labels: {
        show: true,
        style: {
          colors: '#545454',
          fontSize: '13px',
          fontWeight: '500',
          fontFamily: 'inherit',
        },
        maxHeight: 120,
        trim: false,
        rotate: 0,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        show: false,
      },
    },
    yaxis: {
      show: true,
      labels: {
        show: true,
        style: {
          colors: '#545454',
          fontSize: '12px',
          fontWeight: '500',
          fontFamily: 'inherit',
        },
        formatter: function (val) {
          const maxLength = 15; // max character length before truncation
          if (typeof val === 'string' && val.length > maxLength) {
            return val.substring(0, maxLength) + '...';
          }
          return val;
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        show: false,
      },
    },

    grid: {
      show: false,
      borderColor: 'rgba(163, 174, 208, 0.15)',
      strokeDashArray: 3,
      position: 'back',
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      row: {
        colors: undefined,
        opacity: 0.5,
      },
      column: {
        colors: undefined,
        opacity: 0.5,
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    fill: {
      type: "solid",
      colors: ["#6ce5e8", "#41b8d5", "#2d8bba"],
      opacity: 0.9,
    },
    legend: {
      show: false,
      position: 'top',
      horizontalAlign: 'center',
      floating: false,
      fontSize: '13px',
      fontFamily: 'inherit',
      fontWeight: 500,
      labels: {
        colors: '#545454',
        useSeriesColors: false,
      },
      markers: {
        width: 12,
        height: 12,
        strokeWidth: 0,
        strokeColor: '#fff',
        fillColors: undefined,
        radius: 2,
        customHTML: undefined,
        onClick: undefined,
        offsetX: 0,
        offsetY: 0,
      },
      itemMargin: {
        horizontal: 15,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    colors: ["#6ce5e8", "#41b8d5", "#2d8bba"],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        borderRadiusApplication: 'end',
        horizontal: true,
        barHeight: '65%',
        distributed: false,
        rangeBarOverlap: true,
        rangeBarGroupRows: false,
        dataLabels: {
          position: 'top',
        },
        columnWidth: '70%',
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        }
      },
      hover: {
        filter: {
          type: 'lighten',
          value: 0.1,
        }
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'darken',
          value: 0.1,
        }
      },
    },
    stroke: {
      show: false,
      width: 0,
      colors: ['transparent'],
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: {
              barHeight: '60%',
            }
          },
          legend: {
            position: 'bottom',
          }
        }
      }
    ],
    // Remove borders for export
    // export: {
    //   csv: {
    //     filename: "chart-data",
    //   },
    //   svg: {
    //     filename: "chart",
    //   },
    //   png: {
    //     filename: "chart",
    //     width: undefined,
    //     height: undefined,
    //   }
    // }
  };

  const calculateHeight = () => {
    const baseHeight = 60; // Slightly increased height per row for better spacing
    const minHeight = 250; // Increased minimum height
    const maxHeight = 800; // Maximum height
    const legendHeight = 50; // Account for legend space

    const calculatedHeight = Math.max(minHeight, Math.min(maxHeight, finalData.length * baseHeight + legendHeight));
    return calculatedHeight;
  };

  return (
    <>
      {finalData && finalData.length > 0 ? (
        <Box
          height={`${calculateHeight()}px`}
          width="100%"
          position="relative"
          bg="transparent"
          borderRadius="8px"
          paddingLeft={2}
          paddingRight={1}
          paddingBottom={1}
        >
          <Chart
            options={barChartOptionsConsumption}
            series={barChartDataConsumption}
            type='bar'
            height={calculateHeight()}
            width="100%"
          />
        </Box>
      ) : (
        <Box
          height="200px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="#545454"
          fontSize="14px"
        >
          No data available
        </Box>
      )}
    </>
  );
}